<footer class="main-footer">
  <div class="float-left d-none d-sm-block">
    <strong>Phần mềm quản lý ký túc xá.</strong>
    <strong>
      Phát triển bởi công ty công nghệ
      <a href="http://thienan.vn/">Thiên An</a>.</strong
    >
  </div>
</footer>
